// src/hooks/useRoleBackground.js

import describerHome from "../assets/describer_home.png";
import guesserHome from "../assets/guesser_home.png";
import blue from "../assets/backgroundBlue.png";
import pink from "../assets/backgroundPink.png";
import yellow from "../assets/backgroundYellow.png";

/**
 * Custom hook to determine the background style and class name based on the user's role.
 * It returns an object containing the background style and class name.
 */
export const useRoleBackground = (type) => {
  const backgroundMap = {
    describer: describerHome,
    guesser: guesserHome,
    blue: blue,
    pink: pink,
    yellow: yellow,
  };

  const bgImg = backgroundMap[type];

  const bgStyle = bgImg
    ? {
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }
    : {}; // fallback has no inline style

  const className = bgImg ? "min-h-screen" : "min-h-screen bg-aicom_blue";

  return { bgStyle, className };
};
